// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9um2F","question":"styles_question__1H-sS","description":"styles_description__158zl"};